import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAdmin } from './utils/auth';

const AdminRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    return <Navigate to="/login" />;
  }
  
  if (!isAdmin()) {
    return <Navigate to="/banners" />;
  }
  
  return children;
};

export default AdminRoute;

